// extracted by mini-css-extract-plugin
export default {"streamContainer":"styles_streamContainer__+znJ4"};